import { useTranslation } from 'react-i18next';
import { useDeviceDetect } from 'react-easyrocket';
import { Button } from 'src/components/Buttons/Button';
import { Download } from 'src/components/svg/Downloads';
import { useModalContext } from 'src/hooks/useModalContext';
import { useDrawer } from 'src/hooks/useDrawer';
import './styles.css';
import { useSettings } from 'src/modules/settings';
import { Logo } from 'src/config/components/Logo';

export const PWACards = () => {
  const { openModal } = useModalContext();
  const { closeDrawer } = useDrawer();
  const { isIos } = useDeviceDetect();
  const {
    pwa: { promptPwaPopup }
  } = useSettings();

  const handlePWA = () => {
    closeDrawer();
    if (isIos) {
      openModal('IOSSETUP');
      return;
    }
    promptPwaPopup();
  };
  const { t } = useTranslation();
  return (
    <div className="flex flex-col justify-center items-center w-[200px] py-[5px] hover:grayscale-[50%]">
      <div className="pwa-card-wrapper p-[1px] rounded-[10px] w-[60px] h-[60px] max-w-[60px] max-h-[60px] m-auto flex items-center logo-shadow justify-center bg-bg_logo_sidebar">
        <div className=" flex pwa-card justify-center items-center rounded-[10px] w-full h-full">
          <Logo className="w-[36px]" />
        </div>
      </div>
      <p className="text-[12px] font-bold w-full text-center mt-[5px] group-hover:text-text_active_sidebar text-text_primary_sidebar transition-all">
        {t('general.installApp')}
      </p>
      <Button
        title="Download"
        mode="button-primary"
        onClick={handlePWA}
        className="before:rounded-[5px] after:rounded-[5px] rounded-[5px] min-w-[100px] w-auto gap-1 mt-2.5"
        leftIcon={<Download fill="var(--download_sidebar)" className="w-[30px] h-[30px]" />}
      />
    </div>
  );
};
